<template>
	<div class="prod_info" v-if="obj_to_null(this.order)">
		<info_field f_uniq="cid1" :f_title="__t('ORDER.UID')" :f_val="order.order.uniq_id.toString()"></info_field>
		<info_field f_uniq="cid2" :f_title="__t('ORDER.ID')" :f_val="order.order.id.toString()"></info_field>
		<info_field f_uniq="cid3" :f_title="__t('ORDER.CODE')" :f_val="order.order.order_code.toString()"></info_field>

		<info_field  f_uniq="cid4" :f_title="__t('LOAD_FROM')" f_icon="fa-sync" :f_val="providers.agr"></info_field>
		<info_field  f_uniq="cid5" :f_title="__t('ACCEPT_FROM')" f_icon="fa-sync" :f_val="providers.pos"></info_field>

        <div v-if="!order.is_delivery">
            <info_field f_uniq="cid6"  :f_title="__t('ORDER.TOTAL')" f_icon="fa-money-bill" :f_val="order_price.total.toString()"></info_field>
            <info_field f_uniq="cid6"  :f_title="__t('ORDER.SUBTOTAL')" f_icon="fa-money-bill" :f_val="order_price.subtotal.toString()"></info_field>
            <info_field f_uniq="cid6" v-if="parseFloat(order_price.discount) > 0"  :f_title="__t('ORDER.DUSCOUNT')" f_icon="fa-money-bill" :f_val="order_price.discount.toString()"></info_field>
        </div>
		<info_field  f_uniq="cid7" :f_title="__t('O_STATUS')" f_icon="fa-sync" :f_val="order.status"></info_field>

	</div>
</template>

<script>
import Info_field from "../../../sys/info_field";
export default {
	name: "order_info",
	components: {Info_field},
	props : {
		order : {
			type : Object
		}
	},


    computed : {
        order_price() {
            if(this.order.hasOwnProperty("cost")) {
                return this.order.cost;
            }

            return {
                "total" : 0,
                "subtotal" : 0,
                "discount" : 0,
            };
        },

        providers () {

            if(this.order.hasOwnProperty("providers")) {
                return this.order.providers;
            }

            return {
                "agr" : "",
                "pos" : "",
            };
        }
    }
}
</script>

<style scoped>

</style>
